import { BsFillTrash3Fill } from "react-icons/bs";

function CartItem({ name, size, price, quantity }) {
  return (
    <div className="grid grid-cols-12 content-center w-full h-[158px] border-t border-b">
      <input 
        type="checkbox" 
        className="col-span-1 w-3 ml-[15px] md:ml-[52px] accent-[#000068]" 
      />
      <img 
        src="/cart.png" 
        alt="product-image" 
        className="w-80 col-span-3 md:w-36 md:col-span-2" 
      />
      <div className="w-full col-span-3">
        <h1 className="text-xl">{name}</h1>
        <p className="mt-1 text-md">{size}</p>
        <p className="font-bold text-md mt-1.5 text-[#000068]">${price}</p>
      </div>
      <div className="col-span-5 w-full flex flex-col items-center md:col-span-3">
        <div
          className="flex justify-center items-center rounded-lg w-10 h-10 bg-white border-2 border-[#0f1056] text-[#0f1056] font-semibold transition-transform duration-200 hover:scale-105 hover:bg-[#0f1056] hover:text-white shadow-md"
        >
          <span className="cursor-pointer hover:text-[#000068] px-2">-</span>
          <h1>{quantity}</h1>
          <span className="cursor-pointer hover:text-[#000068] px-2">+</span>
        </div>
        <div className="flex justify-around items-center w-[92px] h-[33px] border border-[#000068] mt-2.5 rounded hover:bg-[#000068]/10 transition-colors cursor-pointer">
          <BsFillTrash3Fill className="text-[#000068]" />
          <h1 className="text-[#000068] text-[20px]">Remove</h1>
        </div>
      </div>
      <div className="hidden justify-end w-full col-span-3 h-full md:flex">
        <h1 className="font-bold mr-2 text-[#000068]">${price}</h1>
      </div>
    </div>
  );
}

export default CartItem;
